// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { SET_SERVICE_ACCOUNT_MEMBERSHIP } from "./action";

export function canSetServiceAccountMembership(scope: Scope): boolean {
  return scope.iamActions.includes(SET_SERVICE_ACCOUNT_MEMBERSHIP);
}
